import React, { useState } from 'react';
import "./ChatScreen.css";
import Avatar from '@material-ui/core/Avatar';

function ChatScreen() {
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([
        {
            name: "Steve",
            image: "https://www.biography.com/.image/t_share/MTY2MzU3OTcxMTUwODQxNTM1/steve-jobs--david-paul-morrisbloomberg-via-getty-images.jpg",
            message: "What's up Bro"
        },
        {
            name: "Steve",
            image: "https://www.biography.com/.image/t_share/MTY2MzU3OTcxMTUwODQxNTM1/steve-jobs--david-paul-morrisbloomberg-via-getty-images.jpg",
            message: "Hows it going"
        },
        {
            message: "Doing Great"
        }
    ]);

    const handleSend = e => {
        e.preventDefault();

        setMessages([...messages, {message: input}]);
        setInput("");
    }

    return (
        <div className="chatScreen">
            <p className="chatScreen__timeStamp">You matched with Steve Jobs</p>
            {messages.map(message => (
                message.name ? (
                <div className="chatScreen__mesaage">
                    <Avatar 
                        className="chatScreen__image"
                        alt={message.name}
                        src={message.image}
                    />
                    <p className="chatScreen__text">{message.message}</p>
                </div>
                ) : (
                    <div className="chatScreen__mesaage">
                    <p className="chatScreen__textUser">{message.message}</p>
                </div>
                )
                
            ))}
            <div >
                <form className="chatScreen__input">
                    <input 
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        className="chatScreen__inputField"
                        placeholder="Type a message.."
                        type="text" />
                    <button onClick={handleSend} type="submit" className="chatScreen__inputButton">SEND</button>
                </form>
            </div>
        </div>
    );
}

export default ChatScreen
